/* SNZ KLARNA LINE — 20 Oct 2026 (Z): "add klarna to encourage checkout".
 *
 * Klarna is switched on at checkout through Shopify Payments, but nothing on the
 * storefront says so until the payment page. This prints
 *   "Or 3 interest-free payments of £21.63 with Klarna."
 * under the product price, under the bag drawer's subtotal and under /cart's
 * estimated total, recomputed whenever the price or subtotal changes.
 *
 * UK shoppers only (country GB, GBP), amounts £30–£1,000 (Klarna UK Pay in 3 range).
 * The loader lives in snippets/snz-drawer-perks.liquid, which renders inside the
 * cart drawer on every page, so no edit to the 98KB product section was needed.
 * Klarna's own On-Site Messaging app can replace this once Z adds the Klarna
 * client id from the Klarna merchant portal — then delete this file + loader.
 */
(function () {
  'use strict';
  var tag = document.currentScript;
  if (!tag || tag.getAttribute('data-country') !== 'GB') return;
  if (!(window.Shopify && Shopify.currency && Shopify.currency.active === 'GBP')) return;

  var MIN = 30, MAX = 1000, CLS = 'snz-klarna';

  var css = document.createElement('style');
  css.textContent =
    '.' + CLS + '{margin:6px 0 0;font-family:Montserrat,var(--font-body-family),sans-serif;font-size:12px;line-height:1.5;color:#67736F;letter-spacing:.01em}' +
    '.' + CLS + ' b{font-weight:500;color:#1F2421}' +
    '.' + CLS + '__k{display:inline-block;padding:1px 6px;border-radius:3px;background:#FFA8CD;color:#0E0E0F;font-weight:600;font-size:11px;letter-spacing:.02em;line-height:1.4;vertical-align:baseline}' +
    '.' + CLS + '__fine{display:block;font-size:10px;color:#9A9792;margin-top:1px}' +
    '.' + CLS + '[hidden]{display:none}' +
    '.product__info-container .' + CLS + '{margin:4px 0 10px}' +
    '.cart-drawer__footer .' + CLS + ',.cart__footer .' + CLS + '{text-align:right;margin:2px 0 8px}' +
    '@media (max-width:749px){.cart__footer .' + CLS + '{text-align:left}}';
  document.head.appendChild(css);

  function parse(el) {
    if (!el) return null;
    var m = (el.textContent || '').replace(/,/g, '').match(/£\s*(\d+(?:\.\d{1,2})?)/);
    return m ? parseFloat(m[1]) : null;
  }
  function money(n) {
    return '£' + (Math.round(n * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function line(amount) {
    if (amount === null || amount < MIN || amount > MAX) return '';
    return 'Or 3 interest-free payments of <b>' + money(amount / 3) + '</b> with <span class="' + CLS + '__k">Klarna.</span>' +
      '<span class="' + CLS + '__fine">18+, T&amp;Cs apply, credit subject to status.</span>';
  }
  function place(after, amount) {
    if (!after || !after.parentNode) return;
    var el = after.nextElementSibling;
    if (!el || !el.classList.contains(CLS)) {
      el = document.createElement('p');
      el.className = CLS;
      after.parentNode.insertBefore(el, after.nextSibling);
    }
    var html = line(amount);
    el.hidden = !html;
    if (el.innerHTML !== html) el.innerHTML = html;
  }

  function paint() {
    /* product page: the price block Dawn re-renders on variant change */
    var info = document.querySelector('.product__info-container');
    if (info) {
      var priceBox = info.querySelector('[id^="price-"]');
      var cur = info.querySelector('.price__sale .price-item--sale, .price .price-item--sale');
      var reg = info.querySelector('.price__regular .price-item--regular, .price .price-item--regular');
      var shown = (cur && cur.offsetParent) ? cur : reg;
      if (priceBox) place(priceBox, parse(shown));
    }
    /* bag drawer and /cart: the totals row */
    var totals = document.querySelectorAll('.cart-drawer__footer .totals, .cart__footer .totals');
    for (var i = 0; i < totals.length; i++) {
      place(totals[i], parse(totals[i].querySelector('.totals__total-value')));
    }
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(paint, 60); }

  function start() {
    paint();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n && n.closest && n.closest('.' + CLS)) continue; /* our own writes */
        schedule();
        return;
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      if (PUB_SUB_EVENTS.cartUpdate) window.subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
      if (PUB_SUB_EVENTS.variantChange) window.subscribe(PUB_SUB_EVENTS.variantChange, schedule);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
